// Lokales (Europe/Berlin) YYYY-MM-DD aus einem Date-Objekt — IMMER über
// `getFullYear/getMonth/getDate`, NIE über `toISOString().slice(0,10)`.
// Letzteres liefert in CEST (UTC+2) bei Mitternachts-Dates den Vortag, was
// "Heute"-Marker, Excel-Dateinamen und from/to-Filter um einen Tag
// verschiebt.
export function localYMD(d) {
  const x = d instanceof Date ? d : new Date(d);
  const pad = (n) => String(n).padStart(2, '0');
  return `${x.getFullYear()}-${pad(x.getMonth() + 1)}-${pad(x.getDate())}`;
}

export function todayYMD() {
  return localYMD(new Date());
}
